import { useNavigate } from 'react-router';
import { Button } from '@tempmee/react';
import { OutlineChevronLeftIcon } from '@tempmee/react-icons';
import { Colors } from '~/themes/colors';
import { IBackButtonProps } from './Types';

/**
 * Back button rendered with the @tempmee/react DS Button (ghost / inline).
 * `color` tints both the label and the arrow icon so it stays legible on dark
 * backgrounds (e.g. registration screens pass `Colors.white`).
 */
export const BackButton = ({ onClick, url, color = Colors.secondary_500 }: IBackButtonProps) => {
  const navigate = useNavigate();

  const handleOnClick = () => {
    if (onClick) return onClick();
    if (url) return navigate(url);
    return navigate(-1);
  };

  return (
    <Button
      variant="ghost"
      size="inline"
      type="button"
      onClick={handleOnClick}
      style={{ color }}
      LeadingIcon={<OutlineChevronLeftIcon color={color} />}
    >
      Back
    </Button>
  );
};
